<template>
  <Paper class="product-control">
    <!-- 搜索 -->
    <search ref="search" :searchBlock='searchBlock' @inquire="searchQuery" class="product-control-search"></search>
    <!-- 表格 -->
    <div class="showTable">
        <el-table height="200" border :data="tableData"    >
            <el-table-column
                prop="productCode"
                :label="$translate('lang.E3202103020002', { defaultText: '产品编码' })"
                width="180"
                :show-overflow-tooltip="true">
            </el-table-column>
            <el-table-column
                prop="seqNumber"
                :label="$translate('lang.E3202103020005', { defaultText: '产品序列号' })"
                width="100"
                :show-overflow-tooltip="true">
            </el-table-column>
            <el-table-column
                prop="productName"
                :label="$translate('lang.E3202103020003', { defaultText: '产品名称' })"
                width="200"
                :show-overflow-tooltip="true">
            </el-table-column>
            <el-table-column
                :label="$translate('lang.E3202103020004', { defaultText: '状态' })"
                prop="status"
                sortable
                width="80">
                <template slot-scope="scope">
                    <span :style="{color:scope.row.status==='N'?'red':''}">
                        {{scope.row.status==='Y'?'启用':'停用'}}
                    </span>
                </template>
            </el-table-column>
            <el-table-column
                prop="createUserName"
                :label="$translate('lang.E3202102250026', { defaultText: '创建人' })"
                :show-overflow-tooltip="true">
            </el-table-column>
            <el-table-column
                prop="createTime"
                :label="$translate('lang.E3202102250027', { defaultText: '创建时间' })"
                sortable
                :show-overflow-tooltip="true">
            </el-table-column>
            <el-table-column
                prop="updateUserName"
                :label="$translate('lang.E3202103020006', { defaultText: '更新人' })"
                :show-overflow-tooltip="true">
            </el-table-column>
            <el-table-column
                prop="updateTime"
                :label="$translate('lang.E3202101250011', { defaultText: '更新时间' })"
                sortable
                :show-overflow-tooltip="true">
            </el-table-column>
            <el-table-column
                prop="address"
                :label="$translate('lang.E3202102230005', { defaultText: '操作' })"
                fixed="right">
                <template slot-scope="scope">
                    <el-button
                        type="text"
                        size="small"
                        @click="indexState(scope.row)">
                        {{scope.row.status=='Y'?$translate('lang.E3202102260003', { defaultText: '停用' }):$translate('lang.E3202102260004', { defaultText: '启用' })}}</el-button>
                    <el-button
                        type="text"
                        size="small"
                        @click="goProduct(scope.row)">
                        {{$translate('lang.E3202102260009', { defaultText: '编辑' })}}
                    </el-button>
                </template>
            </el-table-column>
        </el-table>
    </div>
    <!-- 新增按钮 -->
    <el-button @click="goProduct" type="primary" size="mini" icon="el-icon-plus" class="product-control-new-push" >
        {{$translate('lang.E3202102260005', { defaultText: '新增' })}}
    </el-button>
    <!-- 分页 -->
    <page-list v-if="pageState" :pageMenu="pageMenu" @changeCurrent="currentDom" @changeSize="sizeDom" class="product-control-pagelist"></page-list>
  </Paper>
</template>
<script>
import Paper from '@/components/core/paper/Paper';
import search from './search';
import pageList from '../productTemplate/pageList';
import { productSearch, maintainingState } from '../../../api/product';
export default {
    name: 'productcontrol',
    data() {
        return {
            productControlTable: 'inTable',
            pageState: true,
            searchBlock: false,
            pageMenu: {
                totalCount: 0,
                currentPage: 1,
                pageNo: 1, // 初始页
                pageSize: 10, // 每页个数
                pageSizes: [10, 20, 30, 40]
            },
            tableData: []
        };
    },
    components: {
        Paper,
        search,
        pageList
    },
    methods: {
        searchQuery() {
            this.pageState = false;
            this.pageMenu.pageNo = 1;
            this.searchBlock = true;
            this.goQuery();
            this.$nextTick(() => {
                this.pageState = true;
            });
        },
        goQuery() {
            const sendContents = this.$refs.search.sendContents;
            sendContents.pageNo = this.pageMenu.pageNo;
            sendContents.pageSize = this.pageMenu.pageSize;
            if (this.$refs.search.timeHorizon) {
                sendContents.startTime = this.$refs.search.timeHorizon[0];
                sendContents.endTime = this.$refs.search.timeHorizon[1];
            } else {
                sendContents.startTime = '';
                sendContents.endTime = '';
            }
            productSearch(sendContents).then(res => {
                if (+res.code === 0) {
                    this.pageMenu.totalCount = res.data.totalCount;
                    this.tableData = res.data.list;
                }
                this.searchBlock = false;
            }).catch(() => {
                this.searchBlock = false;
            });
        },
        // 去往产品属性页面
        goProduct(row) {
            this.$router.push({
                path: '/producttype',
                query: { id: row.id }
            });
        },
        // 页面启用禁用
        indexState(row) {
            let rows = '';
            this.$confirm(this.$translate('lang.EXC202102260004', { defaultText: '此操作将进行状态更改, 是否继续?' }),
                this.$translate('lang.E3202102220028', { defaultText: '提示' }), {
                    confirmButtonText: this.$translate('lang.E3202101270001', { defaultText: '确定' }),
                    cancelButtonText: this.$translate('lang.E3202101270002', { defaultText: '取消' }),
                    type: 'warning'
                })
                .then(() => {
                    if (row.status === 'Y') {
                        rows = 'N';
                    } else {
                        rows = 'Y';
                    }
                    maintainingState({
                        id: row.id,
                        version: row.version,
                        status: rows
                    }).then(res => {
                        this.$message.success(this.$translate('lang.EXC202102260002', { defaultText: '更改成功!' }));
                        this.goQuery();
                    });
                })
                .catch(() => {
                });
        },
        // 分页1
        currentDom(val) {
            this.pageMenu.pageNo = val;
            this.goQuery();
        },
        // 分页2
        sizeDom(val) {
            this.pageMenu.pageSize = val;
            this.goQuery();
        }
    },
    activated() {
        this.goQuery();
    }
};
</script>
<style  lang='less'>
.product-control{
// 表格高度
    .showTable{
        .el-table {
            height: calc(100vh - 220px) !important;
        }
        .row-bg {
            margin-top: 20px;
        }
        .el-table--border {
            border: 1px solid #EBEEF5;
        }
        .el-table__fixed-right{
            height: 100% !important;
        }
    }
    .product-control-new-push{
        float: left;
        margin-top: 20px;
    }
    // 分页样式
    .product-control-pagelist{
        text-align: right;
        margin-top: 20px;
    }
}
</style>